<template>
  <div id="study">
    <TopNav :isTransparency="true" :backgroundColor="'#ff6a59'" @handleAvatar="$refs.PersonalPopup.show()" @search="jumpRouter({name:'SearchResult'})" />
    <PersonalPopup ref="PersonalPopup" />
    <div class="header"></div>
    <div class="nav">
      <div class="item" @click="jumpRouter({name:'MyResearch',params:{type: 'myResearchDetail'}})">
        <div class="title">我的研究</div>
        <div class="subTitle">查看我的投稿记录</div>
      </div>
      <div class="item" @click="jumpRouter({name:'Periodical'})">
        <div class="title">期刊投稿</div>
      </div>
    </div>
    <StudyTitle title="往期阅览" @click="jumpRouter({name:'PastReading'})" />
    <Empty v-if="!page.readList.length" />
    <div class="pastList" v-else>
      <div class="item" v-for="(item,index) in page.readList" :key="index" @click="jumpRouter({name:'Preview',params:{id:item.id}})" >
        <van-image fit="cover" :src="item.defaultImage || require('@/assets/images/study/img_default_01.png')" />
      </div>
    </div>
    <StudyTitle title="教育视野" @click="jumpRouter({name:'EducationList'})" />
     <!-- @click="jumpRouter({name:'EducationView',params:{id:page.theme.id}})" -->
    <Empty v-if="!page.theme.horizonList.length" />
    <div class="teach" v-else>
      <div class="title">{{ page.theme.title }}</div>
      <div class="teachList">
          <StudyItem v-for="(item,index) in page.theme.horizonList" :key="index" :item="item" @click="jumpRouter({name:'EducationViewDetail',params:{id:item.id}})" />
      </div>
    </div>
    <StudyTitle title="媒体融合" @click="jumpRouter({name:'Media'})" />
    <Empty v-if="!page.mediaList.length" />
    <div class="mediaList" v-else>
      <div class="item" v-for="(item,index) in page.mediaList" :key="index" @click="jumpRouter({name:'StudyMediaDetail',query:{id:item.id,title:item.name}})" >
        <div class="card">
          <van-image class="img" :src="item.image" fit="cover"></van-image>
          <div class="title">{{ item.name }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { TopNav } from '@/components';
import PersonalPopup from '@/views/personal/PersonalPopup';
import StudyTitle from './components/StudyTitle';
import StudyItem from './components/StudyItem';
export default {
  name: 'Study',
  components: { TopNav, PersonalPopup, StudyTitle, StudyItem },
  data () {
    return {
      page: {
        readList: [],
        theme: {
          horizonList: []
        },
        mediaList: []
      }
    };
  },
  watch: {
    $route: {
      handler ({ name }) {
        if (name === 'Study') {
          this.getList();
        }
      },
      immediate: true
    }
  },
  methods: {
    jumpRouter (data) {
      this.$router.push(data);
    },
    getList () {
      this.$http.get('courseTeach/index', { showLoading: true }).then((res) => {
        this.page = res.data;
      });
    }
  }
};
</script>
<style lang="less" scoped>
#study {
  background-color: #F7F8FA;
  .header {
    width: 100%;
    height: 400px;
    background: url('~@/assets/images/study/bg_01.png') no-repeat center center/cover;
  }
  .nav {
    display: flex;
    align-items: center;
    justify-content: space-around;
    .item {
      width: 372px;
      height: 216px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      background: url('~@/assets/images/study/bg_02.png') no-repeat center center/cover;
      &:nth-child(2) {
        background: url('~@/assets/images/study/bg_03.png') no-repeat center center/cover;
      }
      .title {
        margin: 0 38px;
        font-size: 34px;
        color: #fff;
      }
      .subTitle {
        margin: 4px 38px;
        font-size: 20px;
        font-weight: 400;
        color: #fff;
      }
    }
  }
  /deep/ .pastList {
    width: 100%;
    display: flex;
    align-items: center;
    overflow-x: auto;
    padding-left: 8px;
    padding-right: 8px;
    &,* {
      touch-action: manipulation;
    }
    &::-webkit-scrollbar {
      display: none;
    }
    .item {
      width: 150px;
      height: 220px;
      flex-shrink: 0;
      margin-left: 20px;
      margin-right: 20px;

      .van-image {
        width: 100%;
        height: 100%;
        border-radius: 8px;
        overflow: hidden;
        background-color: @primaryGreyBg;
      }
    }
  }
  .teach{
    .title{
      font-weight: bold;
      margin-left: 20px;
      font-size: 32px;
      color: rgb(255, 106, 89);
      margin-bottom: 10px;
    }
    .teachList {
      display: flex;
      flex-wrap: wrap;
    }
  }
  .mediaList {
    display: flex;
    flex-wrap: wrap;
    .item {
      width: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 20px;
      .card {
        width: 336px;
        background-color: #fff;
        border-radius: 8px;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        .img {
          width: 336px;
          height: 224px;
        }
        .title {
          padding: 16px 20px;
          font-size: 26px;
          color: #333444;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }
}
</style>